import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/pc/rhHouse/getProxyHouse', data, {
    trim: true
  })
}
